import { dispatch, redirect, NOT_FOUND } from '@rematch/core';

// 1. Action type <-> url path.
// 2. :id is dynamic route parameter
// 3. Possible to add thunks to send another action on route loading.
// 4. Weird behaviour - rematch dispatch functions need to be awaited before called.
// 5. When getting data based on route - containers used on other routes will not show data.

export const routesMap =  {
  [NOT_FOUND]: {
    path: '/not-found'
  },

  // 'ACTION_NAME': '/url-path-for-action',
  'route/home': { 
    path: '/',
    thunk: async (d, getState) => {
      await dispatch; // wait for rematch to load
      dispatch.page.fetch({id: 'home'})
      dispatch.categories.fetch({})
      dispatch.projects.fetch({})
      dispatch.projects.fetch({ search: 'page=2' })
      // dispatch.projects.noFilters()
      dispatch.projects.setFilter({ filter: 'cat', value: 'highlights' })
    }
  },

  'route/projects': { 
    path: '/projects',
    thunk: async (d, getState) => {
      await dispatch; // wait for rematch to load
      dispatch.categories.fetch({})
      dispatch.projects.fetch({})
      dispatch.projects.noFilters()
    }
  },

  'route/project': {
    path: '/projects/:id',
    thunk: async (d, getState) => {
      await dispatch; // wait for rematch to load
      dispatch.categories.fetch({})
      dispatch.project.reset()
      dispatch.project.fetch({ id: getState().location.payload.id, redirect: true })
    }
  },

  'route/category': {
    path: '/category/:id',
    thunk: async (d, getState) => {
      await dispatch; // wait for rematch to load
      let cat = getState().location.payload.id
      dispatch.categories.fetch({})
      dispatch.projects.fetch({})
      if (getState().projects.query.cat !== cat) {
        if (cat==='all-projects') {
          dispatch.projects.noFilters()
        } else {
          dispatch.projects.setFilter({ filter: 'cat', value: cat })
        }
      }
    }
  },

  'route/page': {
    path: '/:id',
    thunk: async (d, getState) => {
      await dispatch; // wait for rematch to load
      dispatch.categories.fetch({})
      dispatch.page.reset()
      dispatch.page.fetch({ id: getState().location.payload.id, redirect: true })
    }
  },
}



// WEBPACK FOOTER //
// ./src/redux/routes.js